<template>
  <div
    :class="classes"
    @click="selectOption"
  >
    <template v-if="selectedIsArray">
      <i
        v-if="isSelected"
        aria-hidden="true"
        class="multi__icon sb-icon-check_box"
      />
      <i
        v-else
        aria-hidden="true"
        class="multi__icon sb-icon-check_box_outline_blank"
      />
    </template>
    <!-- @slot slot to render empty option text -->
    <slot />
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'

/**
 * Helper component to be used inside nw-options.
 * This is a single option row in nw-options.
 */
export default {
  name: 'NwOption',
  inject: {
    SbSelect: {}
  },
  props: {

    /**
     * Value of the dropdown option. When selected, this will be the value(s) of the dropdown.
     */
    value: {
      required: true
    },

    /**
     * A function used to compare equality of an option to its value.
     * This can be useful if you don't want the value of your option to be the entire option.
     * This might occur if you are using a complex object as an option but maybe only care about the id attribute of that object.
     */
    compareOptionValueFunc: {
      type: Function,
      default: (value) => (option) => isEqual(value, option)
    }
  },
  computed: {
    classes () {
      const classes = ['nw-option']
      if (this.selectedIsArray) classes.push('multi')
      if (this.isSelected) classes.push('selected')
      return classes
    },
    selectedIsArray () {
      return Array.isArray(this.selected)
    },
    options () {
      return this.SbSelect.options
    },
    selected () {
      return this.SbSelect.selected
    },
    option () {
      return this.options.find(this.compareOptionValueFunc(this.value))
    },
    isSelected () {
      if (Array.isArray(this.selected)) return this.selected.some((s) => this.compareOptionValueFunc(s)(this.option))
      return this.compareOptionValueFunc(this.selected)(this.option)
    }
  },
  mounted () {
    if (!this.SbSelect.hasProvidedOptions) this.registerOption()
  },
  methods: {
    selectOption () {
      this.SbSelect.setSelected(this.value)
    },
    registerOption () {
      this.SbSelect.options.push(this.value)
    }
  }
}
</script>

<style scoped lang='scss'>
@import "./style/nw-option";
</style>
